const STORAGE_KEY = 'synapse_pending_signup';

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

function base64ToFile(dataUrl, filename, mimeType) {
  const parts = String(dataUrl).split(',');
  const mime = mimeType || (parts[0].match(/:(.*?);/) || [])[1] || 'image/png';
  const binary = atob(parts[1] || '');
  const len = binary.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new File([bytes], filename || 'profile.png', { type: mime });
}

export async function savePendingSignup({ form, membership }) {
  if (!form || !membership) return;

  let profileDataUrl = null;
  let profileName = 'profile.png';
  let profileType = 'image/png';

  if (form.profile instanceof File) {
    profileDataUrl = await fileToBase64(form.profile);
    profileName = form.profile.name || profileName;
    profileType = form.profile.type || profileType;
  }

  const payload = {
    username: form.username,
    fullname: form.fullname,
    email: form.email,
    password: form.password,
    membership,
    profileDataUrl,
    profileName,
    profileType,
    savedAt: Date.now(),
  };

  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  return payload;
}

export function loadPendingSignup() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}

export function clearPendingSignup() {
  sessionStorage.removeItem(STORAGE_KEY);
}

export function pendingSignupToFormData(pending, checkoutId) {
  if (!pending) return null;

  const formData = new FormData();
  formData.append('username', pending.username);
  formData.append('fullname', pending.fullname);
  formData.append('email', pending.email);
  formData.append('password', pending.password);
  formData.append('membership', pending.membership);
  formData.append('plan', pending.membership);
  formData.append('polar_checkout_id', checkoutId);
  formData.append('checkout_id', checkoutId);

  if (pending.profileDataUrl) {
    const file = base64ToFile(
      pending.profileDataUrl,
      pending.profileName,
      pending.profileType
    );
    formData.append('profile', file);
  }

  return formData;
}

export const MEMBERSHIP_PLANS = [
  {
    id: 'questions',
    title: 'Questions',
    price: '£9.99/mo.',
    image: '/images/questionmark.png',
    toneClass: 'tone-questions',
  },
  {
    id: 'notes',
    title: 'Notes',
    price: '£9.99/mo.',
    image: '/images/file.png',
    toneClass: 'tone-notes',
  },
  {
    id: 'mocks',
    title: 'Mocks',
    price: '£9.99/mo.',
    image: '/images/brain.png',
    toneClass: 'tone-mocks',
  },
  {
    id: 'all_in_one',
    title: 'All in one',
    price: '£19.99/mo.',
    image: '/images/bag.png',
    toneClass: 'tone-all',
  },
];

export function getPlanById(id) {
  return MEMBERSHIP_PLANS.find((plan) => plan.id === id) || null;
}
